<div class="sui-empty-state">
  <i class="sui-icon sui-icon-flask" aria-hidden="true"></i>
  <h3 class="sui-empty-state-title">Work in progress</h3>
  <p class="sui-empty-state-desc">This is a preview of the new Semeris interface. Your account doesn't have access to it yet.</p>
  @if (classicUrl(); as url) {
    <div class="sui-empty-state-actions">
      <a class="sui-btn sui-btn-primary sui-btn-sm" [href]="url">Go back to classic</a>
    </div>
  }
</div>
